const DeleteIcon = () => {
  return (
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 5.25H15" stroke="#E64449" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.5 8.25V12.75" stroke="#E64449" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.5 8.25V12.75" stroke="#E64449" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3.75 5.25L4.5 14.25C4.5 15.0784 5.17157 15.75 6 15.75H12C12.8284 15.75 13.5 15.0784 13.5 14.25L14.25 5.25" stroke="#E64449" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.75 5.25V3C6.75 2.58579 7.08579 2.25 7.5 2.25H10.5C10.9142 2.25 11.25 2.58579 11.25 3V5.25" stroke="#E64449" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  );
};

export default DeleteIcon;
